<template>
  <div class="flex flex-col items-center lg:items-start bg-white
    rounded-4xl sm:rounded-20px py-20 px-40 lg:px-20 lg:py-10 sm:px-5  md:px-10 sm:py-20">
    <conponent
      v-if="template"
      :is="currentInterface"
      :vacancy="template.name"
      :questions="template.questions"
      :instruction="template.instruction"
      :cant-continue="cantContinue"
      @start="currentStep = 3"
      @micro-checked="currentStep = 3"
      @finish-video-test="currentStep = 4"
      @finish-interview="onFinishInterview"
      @send-answer="onSendAnswer"
    />
  </div>
</template>
<script>
import VacancyData from '@/components/Videointerview/VacancyData.vue';
import CheckMicro from '@/components/Videointerview/CheckMicro.vue';
import TestVideo from '@/components/Videointerview/TestVideo.vue';
import FinishScreen from '@/components/Videointerview/FinishScreen.vue';
import Interview from '@/components/Videointerview/Interview.vue';
import FormFile from '@/components/Form/FormFile.vue';

import {
  getTemplate,
  sendCandidateAnswer,
  getVideointerviewTenplate,
  createInterview,
  updateCandidateAnswer,
  finishInterview,
} from '@/api';
import toast from '@/notify';

export default {
  name: 'MainContent',
  components: {
    VacancyData,
    CheckMicro,
    TestVideo,
    Interview,
    FinishScreen,
    FormFile,
  },
  data() {
    return {
      currentStep: 1,
      interfaces: new Map([
        [1, 'VacancyData'],
        [2, 'CheckMicro'],
        [3, 'TestVideo'],
        [4, 'Interview'],
        [5, 'FinishScreen'],
      ]),
      template: null,
      templateRevision: 0,
      videointerviewId: null,
      cantContinue: false,
    };
  },
  async mounted() {
    const { id } = this.$route.params;
    let response = {};

    try {
      response = await getVideointerviewTenplate(id);
    } catch (e) {
      if (e?.response?.status === 409) {
        toast.danger({
          text: this.$t('errors.interview-has-already-been-recorded'),
          duration: 15000,
        });
        return;
      }

      if (e?.response?.status === 404) {
        toast.danger({
          text: this.$t('errors.link-possibly-expired'),
          duration: 15000,
        });
        return;
      }
      toast.danger({
        text: this.$t('errors.service-is-unavailable'),
        duration: 15000,
      });
    }

    const { status, data } = response;

    if (status === 200) {
      try {
        await createInterview({
          applicationId: id,
          templateId: data.template.id,
          templateRevision: data.revision,
        });
      } catch (e) {
        if (e.response.status === 404) {
          toast.danger({
            text: this.$t('errors.link-possibly-expired'),
          });
        }
      } finally {
        const templateResponse = await getTemplate(id);
        const { status: tStatus, data: tData } = templateResponse;
        if (tStatus === 200) {
          this.template = tData.template;
          this.templateRevision = tData.templateRevision;
          this.videointerviewId = tData.id;
        }
      }
    }
  },
  computed: {
    currentInterface() {
      return this.interfaces.get(this.currentStep);
    },
  },
  methods: {
    async onSendAnswer({ file, questionId }) {
      const video = new Blob([file], {
        type: 'video/webm',
      });
      const fd = new FormData();
      const name = `video-${this.videointerviewId}-${questionId}-${new Date()}.webm`;
      fd.append('video', video, name);
      try {
        await sendCandidateAnswer(fd, questionId, this.videointerviewId);
      } catch {
        try {
          await updateCandidateAnswer(fd, questionId, this.videointerviewId);
        } catch {
          toast.danger({
            text: this.$t('errors.service-is-unavailable'),
          });
        }
      }
    },
    async onFinishInterview() {
      this.currentStep = 5;
      await finishInterview(this.videointerviewId);
    },
  },
};
</script>
<style lang="scss">
.video-player-box {
  & .video-js {
    width: 100%;
    height: 100%;
  }

  & .vjs-big-play-button {
    top: 50%!important;
    left: 50%!important;
    transform: translate(-50%, -50%);
  }
}
</style>
